import React from "react";
import { connect } from "react-redux";
import { setPriceFlag } from "../redux/actions";
import { validPriceFlagList } from "../redux/selectors";
import { FormControl } from "react-bootstrap";

function PriceFlag ({
  priceFlag,
  isMsa,
  validPriceFlagList,
  setPriceFlag,
  isPriceFlagEditable
}) {

  return priceFlag === 'CPQ_N/A'
    ? ( <FormControl plaintext readOnly defaultValue="Not Applicable" /> )
    : (
        <FormControl
          as="select"
          value={priceFlag}
          onChange={e => setPriceFlag(e.target.value)}
          disabled={isMsa || !isPriceFlagEditable}
        >
          {validPriceFlagList.map(flag => (
            <option value={flag} key={flag}>
              {flag}
            </option>
          ))}
        </FormControl>
    );

}

export default connect(
  state => ({
    isMsa: state.quote.isMsa,
    priceFlag: state.quote.priceFlag,
    validPriceFlagList: validPriceFlagList(state),
    isPriceFlagEditable: state.quote.items.some(
      item => item.ccBw || item.ccColour
    )
  }),
  { setPriceFlag }
)(PriceFlag);
